import script from "./ApproveSignal.vue?vue&type=script&setup=true&lang=js"
export * from "./ApproveSignal.vue?vue&type=script&setup=true&lang=js"

import "./ApproveSignal.vue?vue&type=style&index=0&id=44901f9a&lang=scss"

const __exports__ = script;

export default __exports__